import { render, staticRenderFns } from "./coupon-add-rate.vue?vue&type=template&id=0a76571d"
import script from "./coupon-add-rate.vue?vue&type=script&lang=js"
export * from "./coupon-add-rate.vue?vue&type=script&lang=js"
import style0 from "./coupon-add-rate.vue?vue&type=style&index=0&id=0a76571d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports